export default {
  init() {
    // JavaScript to be fired on all pages

    // Elements that animate into view the first time they scroll past the
    // bottom of the viewport. Selector => animate.css class to add.
    const reveals = {
      '.banner-right': 'fadeInRight',
      '.banner-left': 'fadeInLeft',
      '.secondary-banner-top': 'fadeInRight',
      '.secondary-banner-bottom': 'fadeInLeft',
      '.future-top': 'fadeInUp',
      '.option-left': 'fadeInLeft',
      '.option-right': 'fadeInRight',
      '.services-top': 'fadeInUp',
      '.services-left': 'fadeInLeft',
      '.services-right': 'fadeInRight',
      '.services-bottom': 'fadeInUp',
      '.testimonial-left': 'fadeInLeft',
      '.testimonial-right': 'fadeInRight',
      '.appointment-right': 'fadeInRight',
      '.appointment-left': 'fadeInLeft',
    };

    // Register each waypoint exactly once and destroy it after it fires.
    // These used to be created inside a window scroll handler, which added
    // a new set of Waypoints on every scroll event until the page froze.
    Object.keys(reveals).forEach((selector) => {
      const $elements = jQuery(selector);

      if (!$elements.length) {
        return;
      }

      $elements.waypoint(function () {
        $elements.addClass(reveals[selector]);
        this.destroy();
      }, { offset: '100%' });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js